(function(){
"use strict";

/*========================================
= 1. Load JSON (pickup-cutoff.json)
========================================*/
const JSON_VERSION="v=124";
const JSON_URL="//www.contis.ph/cdn/shop/t/119/assets/pickup-cutoff.json?v=90454844740003155261765185849?"+JSON_VERSION;

const stores=[];

function setStores(data){
  stores.length=0;
  if(Array.isArray(data)) data.forEach(s=>stores.push(s));
  window.EIT_CutoffUnified=window.EIT_CutoffUnified||{};
  window.EIT_CutoffUnified.stores = stores;
}

fetch(JSON_URL,{cache:"no-store"})
.then(r=>r.ok?r.json():Promise.reject("Cutoff JSON fetch failed"))
.then(j=>{
  setStores(j);
  console.log("[EIT-CUTOFF] JSON loaded",JSON_VERSION,"records:",stores.length);
})
.catch(e=>console.warn("[EIT-CUTOFF] JSON load error:",e));


/*========================================
= 2. Utilities
========================================*/
const months={Jan:1,Feb:2,Mar:3,Apr:4,May:5,Jun:6,Jul:7,Aug:8,Sep:9,Oct:10,Nov:11,Dec:12};

function normalize(s){return (s||"").replace(/\s+/g," ").trim();}
function stripMenuSuffix(n){return normalize(n).replace(/\s*\((full menu|selected items)\)\s*$/i,"");}

function parseISOFromLabel(label){
  if(!label)return null;
  const m=label.match(/(\d{1,2})(st|nd|rd|th)?\s+(\w+)/i);
  if(!m)return null;
  const d=String(parseInt(m[1],10)).padStart(2,"0");
  const mon=months[(m[3]||"").slice(0,3)];
  if(!mon)return null;
  const y=new Date().getFullYear();
  return `${y}-${String(mon).padStart(2,"0")}-${d}`;
}

function parseTimeDecimal(str){
  if(!str) return null;
  const m=str.match(/(\d{1,2})\s*:\s*(\d{2})\s*(AM|PM)/i);
  if(!m)return null;
  let h=+m[1],min=+m[2];
  if(m[3].toUpperCase()=="PM"&&h!==12)h+=12;
  if(m[3].toUpperCase()=="AM"&&h==12)h=0;
  return h+min/60;
}

/*========================================
= 3. Store Finder
========================================*/
function findStoreByName(raw){
  if(!raw)return null;

  const needle=stripMenuSuffix(raw).toLowerCase();

  return stores.find(s =>
     stripMenuSuffix(s.restaurant).toLowerCase()===needle
  ) || stores.find(s =>
     stripMenuSuffix(s.restaurant).toLowerCase().includes(needle)
  ) || stores.find(s =>
     Array.isArray(s.aliases)&&s.aliases.some(a=>{
       a=normalize(a).toLowerCase();
       return a.includes(needle)||needle.includes(a);
     })
  )||null;
}

/*========================================
= 4. Mode Detection
========================================*/
function getActiveMode(){
  const p=document.querySelector("#pickup");
  const d=document.querySelector("#delivery");

  if(d && (d.classList.contains("ZapietEats-DeliveryOption--active")||d.getAttribute("aria-selected")=="true"))
    return "delivery";

  if(p && (p.classList.contains("ZapietEats-DeliveryOption--active")||p.getAttribute("aria-selected")=="true"))
    return "pickup";

  return null;
}

/*========================================
= 5. PICKUP — unchanged
========================================*/
const PickupModule=(function(){

function getC(modal){
  return [...modal.querySelectorAll("button.ZapietButton.ZapietButton--primary")]
    .find(b=>b.textContent.trim().toLowerCase()=="confirm")||null;
}

function readBtn(modal){
  return modal.querySelector(".Zapiet-Calendar__TimePicker__Button")?.textContent.trim()||null;
}

function enforce(){
  if(getActiveMode()!=="pickup")return;
  const modal=document.getElementById("ZapietEats-WidgetModal");
  if(!modal)return;

  const confirm=getC(modal);
  const name=window.ZapietEats?.getSelectedRestaurant?.()?.name ||
             document.querySelector(".ZapietDatePicker__Name")?.textContent.trim()||"";

  const store=findStoreByName(name);
  if(!store){ if(confirm){confirm.disabled=false;confirm.style.opacity="";} return;}

  const dBtn=modal.querySelector(".Zapiet-Calendar__Date--selected");
  if(!dBtn){confirm.disabled=true;confirm.style.opacity="0.4";return;}

  const iso=parseISOFromLabel(dBtn.getAttribute("aria-label"));
  if(!iso){confirm.disabled=true;confirm.style.opacity="0.4";return;}

  const rule=store.rules.find(r=>r.date===iso);
  if(!rule||!rule.pickup){confirm.disabled=false;confirm.style.opacity="";return;}

  const open=+rule.pickup.open, cut=+rule.pickup.cutoff;

  modal.querySelectorAll(".Zapiet-Calendar__TimePicker__List__Item").forEach(i=>{
    const t=parseTimeDecimal(i.innerText.trim());
    if(t==null||t<open||t>cut){i.style.opacity="0.4";i.style.pointerEvents="none";}
    else{i.style.opacity="";i.style.pointerEvents="";}
  });

  const sel=readBtn(modal);
  const t=parseTimeDecimal(sel);
  confirm.disabled = !(t && t>=open && t<=cut);
  confirm.style.opacity=confirm.disabled?"0.4":"";
}

function watch(){
  const modal=document.getElementById("ZapietEats-WidgetModal");
  if(!modal)return setTimeout(watch,200);
  const o=new MutationObserver(()=>setTimeout(enforce,60));
  o.observe(modal,{subtree:true,childList:true,attributes:true});
  modal.addEventListener("click",()=>setTimeout(enforce,60),true);
  setTimeout(enforce,150);
}

return{enforce,watch};
})();

/*========================================
= 6. DELIVERY STRICT MODE (Fixed)
========================================*/
const DeliveryModule=(function(){

function getStore(){
  return document.querySelector(".ChoiceList__option--selected .ChoiceList__title")?.textContent.trim()||"";
}
function modal(){return document.getElementById("ZapietEats-WidgetModal");}
function confirmBtn(m){
 return [...m.querySelectorAll(".Zapiet-Calendar__Buttons .ZapietButton")]
        .find(b=>b.textContent.trim().toLowerCase()=="confirm")||null;
}
function ISO(m){
  const d=m.querySelector(".Zapiet-Calendar__Date--selected");
  return d?parseISOFromLabel(d.getAttribute("aria-label")):null;
}
function timeList(m){
  return m.querySelectorAll(".Zapiet-Calendar__TimePicker__List__Item");
}

/* 🔥 Fix: Run after dropdown opens */
function attachDropdownWatcher(m){
  const btn=m.querySelector(".Zapiet-Calendar__TimePicker__Button");
  if(!btn||btn.dataset.eitBind)return;
  btn.dataset.eitBind="1";
  btn.addEventListener("click",()=>setTimeout(enforce,250)); // waits for DOM load
}

function enforce(){
  // delivery mode detection fix
  const isDelivery = (
      getActiveMode()=="delivery" ||
      document.querySelector(".Zapiet-DeliveryDetails") || 
      document.querySelector(".Zapiet-AddressPicker") ||
      document.querySelector("[data-testid='delivery-details']") ||
      document.querySelector(".ChoiceList__option--selected") // fallback – delivery store selected
  );

if(!isDelivery) return;

  const m=modal();
  if(!m||!stores.length)return;

  attachDropdownWatcher(m);  // <-- critical fix

  let list=timeList(m);
  if(!list.length) return setTimeout(enforce,150);

  const store=findStoreByName(getStore());
  const iso=ISO(m);
  const confirm=confirmBtn(m);

  if(!store||!iso){
    list.forEach(i=>{i.style.opacity="";i.style.pointerEvents="";});
    if(confirm){confirm.disabled=false;confirm.style.opacity="";}
    return;
  }

  const rule=store.rules.find(r=>r.date===iso);
  if(!rule||!rule.delivery){
    list.forEach(i=>{i.style.opacity="";i.style.pointerEvents="";});
    confirm.disabled=false;confirm.style.opacity="";
    return;
  }

  const open=+rule.delivery.open, cut=+rule.delivery.cutoff;

  let valid=false, selectedValid=false;
  const selected=m.querySelector(".Zapiet-Calendar__TimePicker__List__Item--selected");

  list.forEach(i=>{
    const t=parseTimeDecimal(i.innerText.trim());
    if(t==null) return;

    if(t<open||t>cut){
      i.style.opacity="0.35"; i.style.pointerEvents="none";
    }else{
      i.style.opacity=""; i.style.pointerEvents="";
      valid=true; if(i===selected) selectedValid=true;
    }
  });

  confirm.disabled = !(valid && selectedValid);
  confirm.style.opacity = confirm.disabled?"0.4":"";
}

return{enforce};
})();

/*========================================
= 7. INIT
========================================*/
function init(){
  PickupModule.watch();

  function run(){
    try{PickupModule.enforce();}catch(e){}
    try{DeliveryModule.enforce();}catch(e){}
  }

  let t=null;
  function deb(){clearTimeout(t); t=setTimeout(run,120);}

  new MutationObserver(deb).observe(document.body,{subtree:true,childList:true,attributes:true});
  setTimeout(run,300);
}

document.readyState==="loading"
?document.addEventListener("DOMContentLoaded",init)
:init();

/* Debug */
window.EIT_CutoffUnified=window.EIT_CutoffUnified||{};
window.EIT_CutoffUnified.getActiveMode=getActiveMode;

})();
